import { ReactNode } from 'react';

import { ElementId, TrackingData } from '../../types';

function toKebab(key: string): string {
  return key.replace(/[A-Z]/g, m => `-${m.toLowerCase()}`);
}

function dataAttributes(
  data: TrackingData | undefined,
): Record<string, string> {
  if (!data) return {};
  const attrs: Record<string, string> = {};
  for (const [key, value] of Object.entries(data)) {
    attrs[`data-track-data-${toKebab(key)}`] = String(value);
  }
  return attrs;
}

type TrackingScopeProps = {
  elementId: ElementId;
  data?: TrackingData;
  children: ReactNode;
} & Omit<React.HTMLAttributes<HTMLDivElement>, 'style'>;

export const TrackingScope = ({
  elementId,
  data,
  children,
  ...rest
}: TrackingScopeProps) => {
  return (
    <div
      style={{ display: 'contents' }}
      data-track-scope={elementId}
      {...dataAttributes(data)}
      {...rest}
    >
      {children}
    </div>
  );
};
